import { applyMiddleware } from "redux";

import thunk from "redux-thunk";
import logger from "./logger";
import persist from "./persist";
import refetch from "./refetch";

const useLogger = import.meta.env.VITE_APP_MODE === "DEV";

const middlewares = useLogger ? applyMiddleware(thunk, logger, persist, refetch) : applyMiddleware(thunk, persist, refetch);

export default middlewares;
